import React, { useState, useEffect, useRef } from "react";
import { SocketContext } from "../context/socketContext";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { io } from "socket.io-client";
import HomePage from "../pages/home/homePage";
import Layout from "../components/layout/layouts";
import Brands from "../pages/brands/brands";
// import Companies from "../pages/companies/companies";
import Users from "../pages/users/users";
// import History from "../pages/history/history";
import Visitors from "../pages/visitors/visitors";
import Monitor from "../pages/monitor/monitor";
import Agents from "../pages/agents/agents";
import Shortcuts from "../pages/shortcuts/shortcuts";
import Banned from "../pages/banned/banned";
import Personal from "../pages/personal/personal";
import Account from "../pages/account/account";
// import VisitorsMsg from "../pages/visitors/visitorsmsg";
import AddShortcut from "../pages/shortcuts/addshortcut";
import Triggers from "../pages/triggers/triggers";
import AddTriggers from "../pages/triggers/addtriggers";
import Widget from "../pages/widget";
// import Details from "../pages/history/details";
import OfflineStatus from "../pages/offlineStatus/offlineStatus";
import AddStatus from "../pages/offlineStatus/addStatus";
import Tickets from "../pages/tickets/tickets";
import Currenthistory from "../pages/currenthistory/currenthistory";
import Analytics from "../pages/analytics/analytics";
import EditTriggers from "../pages/triggers/editTriggers";
import Departments from "../pages/departments/departments";
import CreateTicket from "../pages/tickets/createTicket";
import { showNotification } from "../helpers/fileChanger";
import { dedupeActiveVisitors, normalizeVisitorUniqueId, visitorsUniqueKeyEqual } from "../helpers/visitorId";
import { isAgentAccountBlocked } from "../helpers/userBlock";
// import AllHistory from "../pages/currenthistory/allHistory";
import DragableModal from "../components/dragableModal/dragableModal";

import { incomingMessage, playNotificationSound } from "../helpers/sounds";
import AgentsRoles from "../pages/agentsroles/AgentsRoles";
import EmailSettings from "../pages/emailSettings";
import EmailTemp from "../pages/emailtemp/EmailTemp";
import { addMessageVisitor, onLeaveServed, removeMessageVisitor } from "../redux/VisitorsJoined/VisitorsJoinedActions";
import OmniChannels from "../pages/omniChannels";
import FeedBack from "../pages/feedBacks/FeedBack";
import { message } from 'antd';
import BotBuilder from "../pages/botBuilder/botBuilder";
import BrandWidgetSettings from "../pages/brands/BrandWidgetSettings";
import { Navigate, useNavigate } from "react-router-dom";
import { SOCKET_EVENTS } from "../constants/socketEvents";
import * as authActionTypes from "../redux/Auth/AuthTypes";
import * as usersActionTypes from "../redux/Users/UsersTypes";
import { persistor } from "../redux/store";
import {
  getStoredAuthToken,
  handleForceLogout,
} from "../helpers/forceLogout";

const MainRoutes = () => {
    const userData = useSelector((state) => state.Auth.userData);
    const authToken = useSelector((state) => state.Auth.token);
    const servedData = useSelector((state) => state.VisitorReducer.data);
    // const dispatch = useDispatch();
    const [Socket, setSocket] = useState(null);
    const [VisitorData, setVisitorData] = useState([]);
    const [SelectedVisitorData, setSelectedVisitorData] = useState(null);
    const [FiltredUers, setFiltredUsers] = useState([]);
    const [connected, setConnected] = useState(false);
    const [TranserStatus, setTranserStatus] = useState([]);
    const [UpdtaedVisitor, setUpdtaedVisitor] = useState(null);
    const [AllActiveVisitors, setAllActiveVisitors] = useState([]);
    const [collapsed, setCollapsed] = useState(() =>
        typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches
    );
    /** true = default: narrow drawer, visitor profile hidden; false = expanded + profile column */
    const [visitorDrawerCompact, setVisitorDrawerCompact] = useState(true);
    const prevVisitorDrawerOpenRef = useRef(false);
    const [settingAllMesage, setSettingAllMesage] = useState(null);

    /** Collapse left (sidebar) when visitor chat drawer is open so the main area stays usable */
    useEffect(() => {
        const visitorDrawerOpen =
            AllActiveVisitors.length > 0 && AllActiveVisitors.some((v) => !v.minimized);
        if (visitorDrawerOpen) {
            setCollapsed(true);
        }
    }, [AllActiveVisitors]);

    /** Reopen drawer in default compact mode (profile hidden) after it was fully closed */
    useEffect(() => {
        const visitorDrawerOpen =
            AllActiveVisitors.length > 0 && AllActiveVisitors.some((v) => !v.minimized);
        if (!visitorDrawerOpen) {
            setVisitorDrawerCompact(true);
            prevVisitorDrawerOpenRef.current = false;
            return;
        }
        if (!prevVisitorDrawerOpenRef.current) {
            setVisitorDrawerCompact(true);
        }
        prevVisitorDrawerOpenRef.current = true;
    }, [AllActiveVisitors]);
    const [isVisible, setIsVisible] = useState(false);
    const [unSeenChat, setUnSeenChat] = useState([]);
    const [openUserChat, setOpenUserChat] = useState(false);
    const [selectedUserChat, setSelectedUserChat] = useState(null);
    const [sidebarSetSelectedKey, setSidebarSetSelectedKey] = useState(null);
    const visitorMessageId = useSelector((state) => state.VisitorReducer.visitorMessageId);
    const overAllUsers = useSelector((state) => state.Users.overAllUsers);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userSoundsRef = useRef(userData?.sounds);

    useEffect(() => {
        userSoundsRef.current = userData?.sounds;
    }, [userData?.sounds]);

    useEffect(() => {
        if (!selectedUserChat?._id || !overAllUsers?.length) return;
        const latest = overAllUsers.find(
            (u) => String(u._id) === String(selectedUserChat._id)
        );
        if (!latest) return;
        if (isAgentAccountBlocked(latest) !== isAgentAccountBlocked(selectedUserChat)) {
            setSelectedUserChat({ ...selectedUserChat, ...latest });
        }
    }, [overAllUsers, selectedUserChat]);

    useEffect(() => {
        if (!("Notification" in window)) {
        } else {
            Notification.requestPermission();
        }
    }, []);

    // const visitorRef = useRef(VisitorData);

    // useEffect(() => {
    //     visitorRef.current = VisitorData;
    // }, [VisitorData]);

    useEffect(() => {
        if (!userData?._id) return;
        const token = authToken || getStoredAuthToken();
        if (!token) return;

        const socket = io(`${process.env.REACT_APP_SOCKET}`, {
            transports: ["websocket", "polling"],
            reconnection: true,
            // Agents must stay online even when the network is flaky.
            // Without this they silently stop receiving visitor messages.
            reconnectionAttempts: Infinity,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 10000,
            randomizationFactor: 0.5,
            timeout: 20000,
            auth: {
                token,
                role: userData?.role,
                visitor: false,
            },
        });

        const onSessionExpired = (data) => {
            handleForceLogout(data?.message, {
                socket,
                dispatch,
                reason: data?.reason,
            });
        };

        socket.on(SOCKET_EVENTS.SESSION_EXPIRED, onSessionExpired);
        setSocket(socket);
        return () => {
            socket.off(SOCKET_EVENTS.SESSION_EXPIRED, onSessionExpired);
            socket.disconnect();
        };
    }, [userData?._id, authToken, dispatch]);

    useEffect(() => {
        if (!Socket) return;
        Socket?.on("VisitorArrive", async (data) => {
            setUpdtaedVisitor(data);
        });
        Socket?.on("emailError", async (data) => {
            message.error({
                content: `email configration error :${data?.source}`,
                duration: 10, // time in seconds
            });
        });
        Socket?.on("emailSuccess", async (data) => {
            message.success({
                content: `${data}`,
                duration: 10, // time in seconds
            });
        });
        // Socket.on(`visitorLeaveConversation`, (data) => {
        //     dispatch(onLeaveServed(data, servedData));
        // });
        return () => {
            Socket.off("VisitorArrive");
            Socket.off("emailError");
            // Socket.off("visitorLeaveConversation");
            Socket.off("emailSuccess");
        }
    }, [Socket]);

    useEffect(() => {
        if (!Socket) return;
        const handleUserLeft = (data) => {
            // Server can emit either `{ unique_id }` or just the string id.
            const leavingId = normalizeVisitorUniqueId(
                typeof data === "string" ? data : data?.unique_id
            );
            if (!leavingId) {
                console.error('[DASHBOARD] Invalid userLeft data:', data);
                return;
            }

            const updated = (VisitorData || []).filter(
                (item) => normalizeVisitorUniqueId(item?.unique_id) !== leavingId
            );
            setVisitorData(updated);
            dispatch(onLeaveServed({ unique_id: leavingId }, servedData));
        };
        Socket.on("userLeft", handleUserLeft);
        return () => {
            Socket.off("userLeft", handleUserLeft);
        };
    }, [Socket, VisitorData, servedData]);
    // Incoming chat line items (brand-wide fan-out so non–room-joiners get notifications)
    useEffect(() => {
        if (!Socket) return;
        const onIncomingChatLine = (data) => {
            setSettingAllMesage(data);
            const isFromVisitor = data?.sender === "visitor" || !data?.sender;
            const isServingVisitor = servedData?.some(served => served?.unique_id === data?.senderID);
            if (isFromVisitor && isServingVisitor) {
                playNotificationSound(
                    incomingMessage,
                    userSoundsRef.current?.incomingMessages
                );
            }
        };
        Socket.on(SOCKET_EVENTS.VISITOR_CHAT_TO_BRAND, onIncomingChatLine);
        return () => {
            Socket.off(SOCKET_EVENTS.VISITOR_CHAT_TO_BRAND, onIncomingChatLine);
        };
    }, [Socket, servedData]);

    useEffect(() => {
        if (!settingAllMesage) return;
        const existingVisitor = AllActiveVisitors.find((visitor) =>
            visitorsUniqueKeyEqual(visitor?.unique_id, settingAllMesage?.senderID)
        );
        if (existingVisitor !== null && existingVisitor !== undefined) {
            if (existingVisitor?.minimized) {
                dispatch(addMessageVisitor({ unique_id: settingAllMesage?.senderID, value: 1 }, visitorMessageId))
                const updatedData = { ...settingAllMesage, status: "delivered" };
                Socket.emit("visitorMsgToServer", updatedData);
                showNotification(settingAllMesage?.senderID, settingAllMesage?.message);
            } else {
                if (existingVisitor?.zIndex === 0) {
                    dispatch(addMessageVisitor({ unique_id: settingAllMesage?.senderID, value: 1 }, visitorMessageId));
                }
                const existingVisitorIndex = AllActiveVisitors?.findIndex((visitor) =>
                    visitorsUniqueKeyEqual(visitor?.unique_id, settingAllMesage?.senderID)
                );
                if (existingVisitorIndex !== -1) {
                    setAllActiveVisitors((visitors) => {
                        const updatedVisitors = [...visitors];
                        updatedVisitors[existingVisitorIndex] = {
                            ...updatedVisitors[existingVisitorIndex],
                            ...UpdtaedVisitor,
                            isOpen: updatedVisitors[existingVisitorIndex]?.isOpen,
                            zIndex: updatedVisitors[existingVisitorIndex]?.zIndex,
                            minimized: updatedVisitors[existingVisitorIndex]?.minimized,
                            isBlink: true,
                        };
                        return dedupeActiveVisitors(updatedVisitors);
                    });
                }
            }
        } else {
            let findVisitor = VisitorData?.find((x) =>
                visitorsUniqueKeyEqual(x?.unique_id, settingAllMesage?.senderID)
            );
            if (findVisitor) {
                const updatedData = { ...settingAllMesage, status: "delivered" };
                Socket.emit("visitorMsgToServer", updatedData);
                showNotification(findVisitor?.unique_id, settingAllMesage?.message);
                // If a visitor drawer is already open, do NOT auto-replace it with this
                // new visitor. Just add the new visitor to the bottom tabs (minimized)
                // and bump the notification badge so the agent can switch manually.
                const hasOpenDrawer = AllActiveVisitors?.some(
                    (v) => v?.zIndex === 1 && v?.minimized === false
                );
                if (hasOpenDrawer) {
                    dispatch(
                        addMessageVisitor(
                            { unique_id: settingAllMesage?.senderID, value: 1 },
                            visitorMessageId
                        )
                    );
                    setAllActiveVisitors((visitors) => {
                        const alreadyIn = visitors?.some((v) =>
                            visitorsUniqueKeyEqual(v?.unique_id, findVisitor?.unique_id)
                        );
                        if (alreadyIn) return visitors;
                        return dedupeActiveVisitors([
                            ...visitors,
                            {
                                ...findVisitor,
                                isOpen: true,
                                zIndex: 0,
                                minimized: true,
                                active: false,
                                isBlink: true,
                            },
                        ]);
                    });
                } else {
                    // Seed the triggering message onto the visitor so the chat
                    // shows it immediately on auto-open (the live event fired
                    // before the chat mounted to receive it).
                    setSelectedVisitorData({ ...findVisitor, seedMessage: settingAllMesage });
                }
            }
        }
        setSettingAllMesage(null);
    }, [settingAllMesage]);
    //// first Messsage + Sound
    // Desktop Notification is only triggered from the settingAllMesage effect (showNotification) to avoid
    // duplicate notifications when the same event both runs this handler and that effect (findVisitor path).
    useEffect(() => {
        if (!Socket) return;

        const handleVisitorFirstMessage = (data) => {
            setSettingAllMesage(data);
        };
        Socket.on("visitorFirstMessage", handleVisitorFirstMessage);
        return () => {
            Socket.off("visitorFirstMessage", handleVisitorFirstMessage);
        };
    }, [Socket]);

  useEffect(() => {
    if (!Socket || !userData?._id) return;

    const handleUserBlocked = (payload) => {
      const blockedUserId = payload?.userId ?? payload?.userID ?? payload?._id;
      const isBlocked =
        typeof payload?.isBlocked === "boolean"
          ? payload.isBlocked
          : isAgentAccountBlocked({ user_status: payload?.user_status });
      if (!blockedUserId) return;

      if (Array.isArray(payload?.users)) {
        dispatch({
          type: usersActionTypes.GET_USER_ALL_SUCCESS,
          payload: payload.users,
        });
      } else if (Array.isArray(payload?.data)) {
        dispatch({
          type: usersActionTypes.GET_USER_ALL_SUCCESS,
          payload: payload.data,
        });
      }

      const isCurrentUser = String(blockedUserId) === String(userData?._id);

      if (isCurrentUser && isBlocked) {
        AllActiveVisitors?.forEach((visitor) => {
          if (
            visitor?.current_conversation?.agentParticipants?.some(
              (x) => String(x?._id) === String(userData?._id)
            )
          ) {
            Socket.emit("agentLeaveRoom", {
              agentId: userData?._id,
              unique_id: visitor?.unique_id,
              endEntireChat: false,
            });
            dispatch(onLeaveServed(visitor, servedData));
          }
        });
        setAllActiveVisitors([]);
        setOpenUserChat(false);
        setSelectedUserChat(null);
        Socket.disconnect();
        dispatch({ type: authActionTypes.USER_LOGOUT });
        localStorage.removeItem("reduxPersist:root");
        sessionStorage.removeItem("reduxPersist:root");
        persistor.purge();
        message.error("Your account has been blocked by an administrator.");
        navigate("/login");
        return;
      }

      if (
        isBlocked &&
        selectedUserChat &&
        String(selectedUserChat?._id) === String(blockedUserId)
      ) {
        setOpenUserChat(false);
        setSelectedUserChat(null);
        message.warning("This agent has been blocked and is no longer available for chat.");
      }
    };

    Socket.on(SOCKET_EVENTS.USER_BLOCKED, handleUserBlocked);
    Socket.on(SOCKET_EVENTS.ADMIN_BLOCKED_USER, handleUserBlocked);
    return () => {
      Socket.off(SOCKET_EVENTS.USER_BLOCKED, handleUserBlocked);
      Socket.off(SOCKET_EVENTS.ADMIN_BLOCKED_USER, handleUserBlocked);
    };
  }, [
    Socket,
    userData?._id,
    AllActiveVisitors,
    servedData,
    selectedUserChat,
    dispatch,
    navigate,
    setOpenUserChat,
    setSelectedUserChat,
    setAllActiveVisitors,
  ]);

    /** Open / focus visitor from table or socket: only one non-minimized at a time; re-clicking active row is a no-op */
    useEffect(() => {
        if (!SelectedVisitorData) return;
        setAllActiveVisitors((visitors) => {
            const existingIndex = visitors.findIndex((visitor) =>
                visitorsUniqueKeyEqual(visitor?.unique_id, SelectedVisitorData?.unique_id)
            );

            if (existingIndex !== -1) {
                const current = visitors[existingIndex];
                const alreadyForeground = current?.zIndex === 1 && current?.minimized === false;

                if (alreadyForeground) {
                    return dedupeActiveVisitors(
                        visitors.map((visitor, index) =>
                            index === existingIndex
                                ? {
                                      ...visitor,
                                      ...SelectedVisitorData,
                                      zIndex: 1,
                                      minimized: false,
                                      isOpen: visitor?.isOpen,
                                      isBlink: visitor?.isBlink,
                                  }
                                : visitor
                        )
                    );
                }

                return dedupeActiveVisitors(
                    visitors.map((visitor, index) => {
                        if (index === existingIndex) {
                            return {
                                ...visitor,
                                ...SelectedVisitorData,
                                zIndex: 1,
                                minimized: false,
                                active: true,
                                isBlink: false,
                                isOpen: visitor?.isOpen,
                            };
                        }
                        return {
                            ...visitor,
                            zIndex: 0,
                            minimized: true,
                            active: false,
                        };
                    })
                );
            }

            const minimizedOthers = visitors.map((v) => ({
                ...v,
                zIndex: 0,
                minimized: true,
                active: false,
            }));

            return dedupeActiveVisitors([
                ...minimizedOthers,
                {
                    ...SelectedVisitorData,
                    isOpen: true,
                    zIndex: 1,
                    minimized: false,
                    isBlink: false,
                    active: true,
                },
            ]);
        });
        setSelectedVisitorData(null);
    }, [SelectedVisitorData]);

    useEffect(() => {
        if (!UpdtaedVisitor) return;
        const existingVisitorIndex = AllActiveVisitors.findIndex((visitor) =>
            visitorsUniqueKeyEqual(visitor?.unique_id, UpdtaedVisitor?.unique_id)
        );
        if (existingVisitorIndex !== -1) {
            setAllActiveVisitors((visitors) => {
                const updatedVisitors = [...visitors];
                updatedVisitors[existingVisitorIndex] = {
                    ...updatedVisitors[existingVisitorIndex],
                    ...UpdtaedVisitor,
                    isOpen: updatedVisitors[existingVisitorIndex]?.isOpen,
                    zIndex: updatedVisitors[existingVisitorIndex]?.zIndex,
                    minimized: updatedVisitors[existingVisitorIndex]?.minimized,
                    isBlink: updatedVisitors[existingVisitorIndex]?.isBlink,
                };
                return dedupeActiveVisitors(updatedVisitors);
            });
        }
        setUpdtaedVisitor(null);

    }, [UpdtaedVisitor]);

    useEffect(() => {
        const handleVisibilityChange = () => {
            setIsVisible(document.hidden);
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    return (
        <SocketContext.Provider
            value={{
                selectedUserChat,
                setSelectedUserChat,
                unSeenChat,
                setUnSeenChat,
                openUserChat,
                setOpenUserChat,
                AllActiveVisitors,
                setAllActiveVisitors,
                setTranserStatus,
                TranserStatus,
                setFiltredUsers,
                FiltredUers,
                connected,
                setSelectedVisitorData,
                SelectedVisitorData,
                Socket,
                VisitorData,
                setVisitorData,
                sidebarSetSelectedKey,
                setSidebarSetSelectedKey,
            }}>
            <Layout
                setAllActiveVisitors={setAllActiveVisitors}
                AllActiveVisitors={AllActiveVisitors}
                setCollapsed={setCollapsed}
                collapsed={collapsed}
                visitorDrawerCompact={visitorDrawerCompact}>
                <DragableModal
                    setAllActiveVisitors={setAllActiveVisitors}
                    AllActiveVisitors={AllActiveVisitors}
                    visitorDrawerCompact={visitorDrawerCompact}
                    onVisitorDrawerCompactChange={setVisitorDrawerCompact}
                />
                <Routes>
                    <Route index path="/" element={<HomePage />} />
                    <Route path="/brands" element={<Brands />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/analytics" element={<Analytics />} />
                    <Route path="/visitors" element={<Visitors />} />
                    <Route path="/monitor" element={<Monitor />} />
                    <Route path="/agents" element={<Agents />} />
                    <Route path="/shortcuts" element={<Shortcuts />} />
                    <Route path="/banned" element={<Banned />} />
                    <Route path="/personal" element={<Personal />} />
                    <Route path="/account" element={<Account />} />
                    <Route path="/shortcuts/addshortcut" element={<AddShortcut />} />
                    <Route path="/triggers" element={<Triggers />} />
                    <Route path="/triggers/addtriggers" element={<AddTriggers />} />
                    <Route path="/triggers/edit/:triggerIdForEdit" element={<EditTriggers />} />
                    <Route path="/departments" element={<Departments />} />
                    <Route path="/widget" element={<Navigate to="/brands" replace />} />
                    <Route path="/brands/:brandId" element={<BrandWidgetSettings />} />
                    <Route path="/offlineStatus" element={<OfflineStatus />} />
                    <Route path="/offlineStatus/status" element={<AddStatus />} />
                    <Route path="/tickets" element={<Tickets />} />
                    <Route path="/create-ticket" element={<CreateTicket />} />
                    <Route path="/history" element={<Currenthistory />} />
                    <Route path="/feedback" element={<FeedBack />} />
                    <Route path="/faqs" element={<Navigate to="/brands" replace />} />
                    {/* <Route path="/botBuilder" element={<BotBuilder />} /> */}
                    {/* <Route path="/all-history" element={<AllHistory />} /> */}
                    <Route path="/agent-roles" element={<AgentsRoles />} />
                    <Route path="/email-settings" element={<EmailSettings />} />
                    <Route path="/email" element={<EmailTemp />} />
                    <Route path="/omnichannels" element={<OmniChannels />} />
                    <Route path="*" element={<HomePage />} />
                </Routes>
            </Layout>
        </SocketContext.Provider >
    );
}

export default MainRoutes;